/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Event_ExcludedInputs */



/**
* | output |
* | --- |
* | "Excluded" |
*
* @param {Partner_Admin_Commission_Event_ExcludedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_event_excluded = /** @type {((inputs?: Partner_Admin_Commission_Event_ExcludedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Event_ExcludedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht anrechenbar")
	return /** @type {LocalizedString} */ ("Excluded")
});